// extracted by mini-css-extract-plugin
export default {"savedCardList":"SavedCardList_savedCardList__gDKCH"};